export default [{
    label: 'ID',
    value: 'id'
}, {
    label: 'Email',
    value: 's_email'
}, {
    label: 'Unit',
    value: 's_unit'
}, {
    label: 'Employee Number',
    value: 'i_employee_number'
}, {
    label: 'First Name',
    value: 's_first_name'
}, {
    label: 'Last Name',
    value: 's_last_name'
}, {
    label: 'Job Title',
    value: 's_job_title'
}, {
    label: 'Department',
    value: 's_department'
}, {
    label: 'Phone Number',
    value: 's_phone_num'
},  {
    label: 'Date of Hire',
    value: 'd_hire'
}, {
    label: 'Work Type',
    value: 's_work_type'
}, {
    label: 'Status',
    value: 's_status'
}, {
    label: 'Created Date',
    value: 't_created'
}, {
    label: 'Created by',
    value: 's_created_by'
}, {
    label: 'Modified Date',
    value: 't_modified'
}, {
    label: 'Modified by',
    value: 's_modified_by'
}, {
    label: 'Access Level',
    value: 'i_access_level'
}, {
    label: 'Internal',
    value: 'b_internal'
}, {
    label: 'Airline',
    value: 'b_airline'
}, {
    label: 'Airline Codes',
    value: 's_airline_codes'
}];
